import React from 'react';

export const CreateUsers = React.lazy(() => import('./CreateUser/CreateUser'));
export const EditUser = React.lazy(() => import('./EditUser/EditUser'));
